export default {
    label: 'Contact us',
    description: 'Dear client, please contact our driver service hotline at +420 296 333 666.',
    submitButton: 'Call'
}
